<template>
  <div class="page-content refunds">
    <div class="row">
      <div class="col-sm-6 col-12">
        <mark-end-call-log />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const MarkEndCallLog = defineAsyncComponent(() => import('./Calls/MarkEndCallLog.vue') as any);

util.moveToTop();
</script>
